import api from "../utils/API";

/**
 * Lance le scan de la base candidat et retourne les groupes de doublons
 * (regroupés par LinkedIn normalisé, puis email).
 */
const scanDuplicates = () => {
  return api.get(`/candidatsmanagement/candidat/duplicates`);
};

/**
 * Détail complet des candidats d'un groupe (champs + process + tâches + notes)
 * pour l'écran de comparaison / fusion.
 * @param {string[]} ids
 */
const getMergePreview = (ids) => {
  const query = encodeURIComponent(ids.join(","));
  return api.get(`/candidatsmanagement/candidat/duplicates/preview?ids=${query}`);
};

/**
 * Fusionne les candidats perdants vers le candidat gardé, avec les valeurs de
 * champs choisies. Les combinaisons de valeurs texte (2, 3 ou toutes) sont
 * concaténées côté client et passées via fieldOverrides. combineFields
 * (optionnel, côté backend) concatène les valeurs de tous les candidats.
 * keepNoteIds / keepFileIds listent les notes et CV à conserver
 * (absent = tout garder, [] = tout supprimer).
 * @param {{keeperId: string, loserIds: string[], fieldOverrides: Object, combineFields?: string[], keepNoteIds?: string[], keepFileIds?: string[]}} payload
 */
const mergeCandidats = (payload) => {
  return api.post(`/candidatsmanagement/candidat/duplicates/merge`, payload);
};

const DuplicateService = {
  scanDuplicates,
  getMergePreview,
  mergeCandidats,
};

export default DuplicateService;
